import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, timesheetDeadline }) =>
    present(
      repository
        .editTimesheetDeadline(planzone, timesheetDeadline)
        .then((savedPlanzone) => ({
          planzone: savedPlanzone,
          timesheetDeadline,
        }))
        .catch((error) =>
          Promise.reject({ error, planzone, timesheetDeadline }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
